import { Component, OnInit, Injectable, OnDestroy } from '@angular/core';
import { OpenSpace } from 'src/app/entities/openSpace';
import { OpenSpaceService } from 'src/app/services/open-space.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subscription } from 'rxjs';
import { debounce } from 'rxjs/operators';
import {Router} from "@angular/router";

@Component({
  selector: 'app-open-selector',
  templateUrl: './open-selector.component.html',
  styleUrls: ['./open-selector.component.css']
})

@Injectable()
export class OpenSelectorComponent implements OnInit, OnDestroy {

  constructor(private openSpaceService: OpenSpaceService, private storage: StorageMap, private router: Router) { }

  openSpaces: OpenSpace[];
  openContent: any;
  openSpaceId: number;
  dataSubscription: Subscription;

  ngOnInit(): void {
    this.getOpenList();
  }

  watchForOpenSapcesChanges(){
    this.openSpaceService.opensChanged.subscribe((_: any) =>
        this.getOpenList()
    );
  }

  watchOpenIdStorage(){
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)){
          this.openSpaceId = openIdInt;
        }
      });
    }

  selectOpenSpace(){
    this.storage.set('selectedOpenId', this.openSpaceId.toString()).subscribe({
      next: () => {
          this.router.navigate(["/dashboard/" + this.openSpaceId]);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  getOpenList() {
    this.openSpaceService.getCurrentOpenSpaces()
    .subscribe(data => {
        this.openContent = data;
        this.openSpaces = this.openContent.OpenSpaces;
        this.selectOpenForDefult();
        this.watchForOpenSapcesChanges();
        this.watchOpenIdStorage();
    },
    error => {
      console.error(error);
    });
  }

  selectOpenForDefult(){
    if (this.openSpaceId === undefined && this.openSpaces?.length > 0)
         {
           this.storage.get('selectedOpenId', { type: 'string' }).subscribe((openId) => {
            const openIdInt = parseInt(openId, 10);
            if (isNaN(openIdInt)){
              this.openSpaceId = this.openSpaces[0].id;
              this.selectOpenSpace();
            }
          });
        }
  }

  ngOnDestroy() {
    this.cleanStorage();
  }

  private cleanStorage() {
    this.storage.delete('selectedOpenId').subscribe(() => { });
    this.storage.clear().subscribe(() => { });
  }
}
